export const labeledImageDefaultContent = {
    en: {
        labeledImageTexts: {
            1: {
                heading: 'Date',
                text: 'Every check needs a date. Without one, the bank won’t accept it.',
            },
            2: {
                heading: 'Recipient’s Name',
                text: 'Write the legal name (first name & last name if it’s a person).',
            },
            3: {
                heading: 'Numeric Amount',
                text: 'Write the amount of the check numerically. For example, $5.75.',
            },
            4: {
                heading: 'Spell Out the Dollar Amount',
                text: 'Spell out the dollar amount textually, for example, One-hundred fifty and 52/100.',
            },
            5: {
                heading: 'Sign the Check',
                text: 'Sign your full name on the check’s signature line.',
            }
        }
    },
    es: {
        labeledImageTexts: {
            1: {
                heading: 'Fecha',
                text: 'Cada cheque necesita una fecha. Sin uno, el banco no lo aceptará.',
            },
            2: {
                heading: 'Nombre del destinatario',
                text: 'Escriba el nombre legal (nombre y apellido si es una persona).',
            },
            3: {
                heading: 'Cantidad numérica',
                text: 'Escriba el monto del cheque numéricamente. Por ejemplo, $5,75.',
            },
            4: {
                heading: 'Deletrea la cantidad en dólares',
                text: 'Explique textualmente el monto en dólares, por ejemplo, ciento cincuenta y 52/100.',
            },
            5: {
                heading: 'Firma el cheque',
                text: 'Firme su nombre completo en la línea de firma del cheque.',
            }
        }
    }
}
